import { render, staticRenderFns } from "./project-replica.vue?vue&type=template&id=b8075bbc&scoped=true&"
import script from "./project-replica.vue?vue&type=script&lang=js&"
export * from "./project-replica.vue?vue&type=script&lang=js&"
import style0 from "./project-replica.vue?vue&type=style&index=0&id=b8075bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8075bbc",
  null
  
)

export default component.exports